var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_798_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9637 0H1.03359C0.462109 0 0 0.451172 0 1.00898V12.9883C0 13.5461 0.462109 14 1.03359 14H12.9637C13.5352 14 14 13.5461 14 12.991V1.00898C14 0.451172 13.5352 0 12.9637 0ZM4.15352 11.9301H2.07539V5.24726H4.15352V11.9301ZM3.11445 4.33672C2.44727 4.33672 1.90859 3.79805 1.90859 3.13359C1.90859 2.46914 2.44727 1.93047 3.11445 1.93047C3.77891 1.93047 4.31758 2.46914 4.31758 3.13359C4.31758 3.79531 3.77891 4.33672 3.11445 4.33672ZM11.9301 11.9301H9.85469V8.68164C9.85469 7.90781 9.84101 6.90977 8.77461 6.90977C7.69453 6.90977 7.53047 7.75469 7.53047 8.62695V11.9301H5.45781V5.24726H7.44844V6.16055H7.47578C7.75195 5.63555 8.43008 5.08047 9.43906 5.08047C11.5418 5.08047 11.9301 6.46406 11.9301 8.26328V11.9301Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_798_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7d2a73d5abe8a3be11fec7fa26af1a0e.svg";
export { ForwardRef as ReactComponent };